@if (isLoading) {
<div class="loading-wrapper">
    <mat-spinner diameter="90"></mat-spinner>
    <h3>Cargando...</h3>
</div>
} @else {
<h2 mat-dialog-title>Menús para: {{ tomorrowsDate | date: 'dd/MM/yyyy' }}</h2>

<mat-dialog-content>
    Menús reservados: {{ menuStats.reservedMenus }}
    <br /><br />

    <mat-form-field appearance="outline" style="width: 150px;">
        <mat-label>Menús extra</mat-label>
        <input matInput type="number" [(ngModel)]="menuStats.extraMenus" min="0"
            (ngModelChange)="onExtraMenusChange()" />
    </mat-form-field>

    <mat-divider></mat-divider>
    <br />

    <div class="stats">
        Menús: {{ menuStats.normalMenus }}<br />
        Celíacos: {{ menuStats.celiacMenus }}<br />
        Invitados: {{ menuStats.totalGuests }}<br />
        Invitados celíacos: {{ menuStats.celiacGuests }}<br />
        Extra: {{ menuStats.extraMenus }}<br />
        <strong>Total: {{ menuStats.total }}</strong>
    </div>

    @if (celiacMenuDetails.length > 0) {
    <mat-divider></mat-divider>
    <br />
    <div class="celiac-details">
        <strong>Detalles menús celíacos:</strong>
        <ul>
            @for (detail of celiacMenuDetails; track $index) {
            <li>{{ detail }}</li>
            }
        </ul>
    </div>
    }
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions align="end">
    <button mat-button class="delete" (click)="onSendMenus()">Enviar</button>
    <button mat-button class="cancel-menu" (click)="onCancel()">Cancelar</button>
</mat-dialog-actions>
}